export default "__VITE_ASSET__BZ2F0yWn__"